import React, { useCallback, useState } from "react";
import { Container, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  useAddBlogPostMutation,
  useUploadBlogPostImageMutation,
} from "../slices/blogPostsApiSlice";
import { useDeleteImageMutation } from "../slices/imageApiSlice";
import "./AddBlog.css";
import EditorQuill from "./EditorQuill";
import GoToTop from "./GoToTop";
import Header from "./Header";
import UploadButton from "./UploadButton";

const categories = ["타로 카드", "타로 리딩", "타로 역사", "그외"];

const AddBlog = () => {
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [image, setImage] = useState("");
  const [abstract, setAbstract] = useState("");
  const [content, setContent] = useState("");
  const navigate = useNavigate();
  const [addBlogPost, { isLoading }] = useAddBlogPostMutation();
  const [uploadBlogPostImage, { isLoading: loadingUpload }] =
    useUploadBlogPostImageMutation();
  const [deleteImage] = useDeleteImageMutation();
  const [imageUrls, setImageUrls] = useState(new Set()); // State to store image URLs from EditorQuill

  const handleImageUrlsChange = useCallback((newImageUrls) => {
    setImageUrls(newImageUrls); // Update the state with the new set of image URLs
  }, []);
  const handleTitleChange = (e) => {
    setTitle(e.target.value);
  };
  const handleAbstractChange = (e) => {
    setAbstract(e.target.value);
  };

  const handleCategoryChange = (e) => {
    setCategory(e.target.value); // Update the selected category
  };

  const handleEditorChange = useCallback((newContent) => {
    setContent(newContent);
  }, []);

  const uploadFileHandler = async (e) => {
    const formData = new FormData();
    formData.append("image", e.target.files[0]);
    try {
      const res = await uploadBlogPostImage(formData).unwrap();
      setImage(res.image);
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    for (const imageUrl of imageUrls) {
      const filename = imageUrl.split("/").pop();
      try {
        await deleteImage(filename).unwrap();
      } catch (err) {
        toast.error(err?.data?.message || "Failed to delete image");
      }
    }
    try {
      await addBlogPost({ title, category, image, abstract, content }).unwrap();
      toast.success("성공적으로 작성되었습니다");
      navigate("/tarot-master");
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  return (
    <div className="mx-auto px-5">
      <Header
        title="새로운 글 작성"
        text={`오늘은 어떤 내용에 대해 작성하실건가요?`}
      />
      <Container>
        <Form className="new-blog-container">
          <Form.Group controlId="formTitle" className="py-2">
            <Form.Label>제목</Form.Label>
            <Form.Control
              type="text"
              placeholder="제목을 입력해주세요"
              value={title}
              onChange={handleTitleChange}
            />
          </Form.Group>

          <Form.Group controlId="formCategory" className="py-2">
            <Form.Label>카테고리</Form.Label>
            <Form.Control
              as="select"
              value={category}
              onChange={handleCategoryChange}
            >
              <option value="" disabled>
                카테고리를 선택해주세요
              </option>
              {categories.map((cat, index) => (
                <option key={index} value={cat}>
                  {cat}
                </option>
              ))}
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="formImage" className="py-2">
            <Form.Label>이미지</Form.Label>
            <Form.Control
              type="file"
              onChange={uploadFileHandler}
              name="formImage"
            />
          </Form.Group>
          <Form.Group controlId="formTitle" className="py-2">
            <Form.Label>요약</Form.Label>
            <Form.Control
              type="text"
              placeholder="글에 대한 요약을 적어주세요 (2-3줄)"
              value={abstract}
              onChange={handleAbstractChange}
            />
          </Form.Group>

          <EditorQuill
            placeholder="오늘은 무엇에 대해 쓰실건가요?"
            onContentChange={handleEditorChange}
            onImageUrlsChange={handleImageUrlsChange}
          />
          <div className="d-flex justify-content-center align-items-center">
            <UploadButton onComplete={handleSubmit} link="/tarot-master" />
          </div>
        </Form>
      </Container>
      <GoToTop />
    </div>
  );
};

export default AddBlog;
